import React, { createContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { findSite } from "../services/principal";
import { Principal } from "../types/principal";
import { fonts, title, icon } from "../utils/configs";
import { isLocalhost } from "../utils/stage";

type ListenerDataProps = {
  children: React.ReactNode;
};

export type ListenerDataContextData = {
  data?: Principal;
  isError: boolean;
  isLoading: boolean;
};

export const ListenerDataContext = createContext<ListenerDataContextData>(
  {} as ListenerDataContextData
);

export function ListenerDataProvider({ children }: ListenerDataProps) {
  const [data, setData] = useState<Principal>();
  const query = useMemo(
    () => new URLSearchParams(window.location.search),
    [window.location.search]
  );

  const company = isLocalhost ? "testeelias" : location.pathname.split("/")[1];
  const handleFindInfo = useQuery(
    ["info", company],
    async () => {
      const response = await findSite(
        `https://datasalesio-imagens.s3.amazonaws.com/sites/${company}.json`
      );

      return response;
    },
    {
      cacheTime: 0,
      onSuccess: (response) => {
        if (response.footer?.whatsapp) {
          response.footer.whatsapp = response.footer.whatsapp.replace(
            /\D/g,
            ""
          );
        }

        setData(response);
        fonts(response.general.fontFamily);
        title(response.general.title);
        icon(response.store.image);
      },
    }
  );

  useEffect(() => {
    if (query.get("mode") && query.get("mode") === "edit") {
      window.addEventListener("message", (event: any) => {
        const json = JSON.parse(event.data);
        setData(json);
        fonts(json.general.fontFamily);
        title(json.general.title);
      });
    }
  }, [query]);

  const listenerDataContextData = useMemo(() => {
    return {
      data,
      isError: handleFindInfo.isError,
      isLoading: handleFindInfo.isLoading,
    };
  }, [data, handleFindInfo.isError, handleFindInfo.isLoading]);

  return (
    <ListenerDataContext.Provider value={listenerDataContextData}>
      {children}
    </ListenerDataContext.Provider>
  );
}
